import $ from "jquery";

$(function() {
    if($(".bl-vorgehen").length == 0) {
        return;
    }

    const $allItems = $(".bl-vorgehen .highlightable");

    /*
    //Version 1: Only one element highlighted at a time. Suitable for large elements.
    function getHighlightedElement()
    {
        const xpos = window.innerWidth*0.5;
        const ypos = window.innerHeight*0.5;

        const elements = document.elementsFromPoint(xpos, ypos);
        for(const element of elements) {
            if(element.classList.contains("highlightable")) {
                return element;
            }
        }
        return null;

    }

    function updateHighlight()
    {
        const hlel = getHighlightedElement();
        if(hlel) {
            const $hlel = $(hlel);
            if($hlel.hasClass("highlighted")) {
                //already highlighted => do nothing
                return;
            }
            $allItems.removeClass("highlighted");
            $(hlel).addClass("highlighted");
        }
    }
    */

    //Version 2: All visible elements highlighted. Except those at bottom of screen. Suitable for many small elements.
    function updateHighlight() {
        const viewportHeight = window.innerHeight;
    
        $allItems.each(function() {
            const itemRect = this.getBoundingClientRect();
            const highlighted = itemRect.top <= 0.75 * viewportHeight;
            $(this).toggleClass("highlighted", highlighted);
        });
    }

    window.setInterval(updateHighlight, 250);
    updateHighlight();
});

